<template>
    <Modal :title="$t('common.downloadCsvReport.modal.title')"
           :close-on-click-outside="false"
           @close="closeModal"
    >
        <template v-slot:body>
            <form class="base_margin modal-content" style="margin-top: 0">
				<div class="text_left">
					<md-radio v-model="form.fileType" :value="'xlsx'">
						{{ $t("common.format.xlsx") }}
					</md-radio>
					<md-radio v-model="form.fileType" :value="'csv'">
						{{ $t("common.format.csv") }}
					</md-radio>
				</div>

                <DatePicker
                    v-on:input="changeDate"
                    :value="form.dateRange"
                    :placeholder="$t('common.assignmentDate')"
                    type="daterange"
                ></DatePicker>
            </form>
            <div class="flex flex_between base_margin">
                <md-button class="md-blank" @click="closeModal">
                    {{$t("common.button.close")}}
                </md-button>
                <md-button class="opacity_5" :class="{ 'md-primary': submitBtnStatus }" @click="download">
                    {{$t("common.download")}}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import DatePicker from "@/components/templates/DatePicker";
import {allReceivablesApi} from "@/common/api/allReceivablesApi";
import Modal from "@/components/templates/modal/Modal";
import {mapActions, mapGetters} from "vuex";

export default {
    props: {
        accountId: { type: Number }
    },
    components: {
        Modal,
        DatePicker
    },
    data() {
        return {
            form: {
                dateRange: ["", ""],
				fileType: "xlsx",
            },
        };
    },
	created() {
		this.form.fileType = this.sellerPreferences.reportFileType;
	},
	computed: {
		...mapGetters({
			sellerPreferences: "local/sellerPreferences"
		}),
        exportCsvUrl() {
          let option = {
            fromDate: this.form.dateRange[0],
            toDate: this.form.dateRange[1],
			fileType: this.form.fileType,
          };
          return allReceivablesApi.exportCsvUrl(option);
        },
        submitBtnStatus() {
            return this.form.dateRange.every(value => value !== "");
        }
    },
    methods: {
		...mapActions({
			setSellerPreferences: "local/setSellerPreferences"
		}),
        download() {
            if (!this.submitBtnStatus) {
                return;
            }

			// Save file type selection locally
			this.setSellerPreferences({ reportFileType: this.form.fileType });

            window.open(this.exportCsvUrl, "_blank");
            this.closeModal();
        },
        closeModal() {
            this.$emit("close");
        },
        changeDate(dateRange) {
            this.form.dateRange = dateRange;
        },
    }
};
</script>
